import { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form/dist/index.ie11';
import React, { ChangeEvent } from 'react';
import { conformToMask } from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { IInputProps, Input } from 'src/components/Input/Input';

export const STANDARD_MAX_BUDGET_DOLLAR_AMOUNT = 800;
export const ENTERPRISE_MAX_BUDGET_DOLLAR_AMOUNT = 10000;

const currencyMask = createNumberMask({
  allowDecimal: true,
});

export interface ICurrencyInputProps extends IInputProps {
  control: Control;
  required?: boolean;
  isEnterprise?: boolean;
  errorMessages?: { [key: string]: string };
}
export function CurrencyInput({
  label,
  name,
  id,
  error,
  control,
  required,
  isEnterprise,
  placeholder,
  isSmall,
  subDescription,
  errorMessages = {},
}: ICurrencyInputProps): JSX.Element {
  const maxBudget = isEnterprise
    ? ENTERPRISE_MAX_BUDGET_DOLLAR_AMOUNT
    : STANDARD_MAX_BUDGET_DOLLAR_AMOUNT;

  function getFormattedCurrency(value: string): string {
    const { conformedValue } = conformToMask(value, currencyMask, {
      guide: false,
    });

    return conformedValue;
  }

  return (
    <Controller
      name={name}
      rules={{
        required: required ? errorMessages.required : false,
        pattern: {
          value: /^\$(\d{1,3}(,\d{3})*|(\d+))(\.\d{2})?$/,
          message: errorMessages.pattern,
        },
        validate: (value: string) => {
          const decimalString = value.replace(/[$,]/g, '');
          const decimalNumber = Number(decimalString);

          const isValidAmount = decimalNumber > 0 && decimalNumber <= maxBudget;

          return isValidAmount || `Amount should be $${maxBudget} or less`;
        },
      }}
      control={control}
      render={({ value = '', name, onChange, onBlur }) => (
        <Input
          id={id}
          label={label}
          placeholder={placeholder}
          name={name}
          value={value}
          isSmall={isSmall}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            onChange(getFormattedCurrency(e.target.value))
          }
          onBlur={onBlur}
          error={error}
          subDescription={subDescription}
        />
      )}
    />
  );
}
